<div class="page-layout carded fullwidth inner-scroll">
  <div class="center">
    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
      <span class="h1" [translate]="'GROUPS.TITLE'"> Groups </span>

      <div class="page-buttons" fxHide.xs>
        <button
          mat-stroked-button
          matTooltip="{{ 'GROUPS.CREATE_GROUP' | translate }}"
          [disabled]="!hasCreateGroupPermission"
          (click)="openDialog()"
        >
          <i
            matTooltipPosition="left"
            class="angularjs-fuse-icon icon-plus"
            [matTooltip]="'GROUPS.PERMISSIONS.NO_CREATE' | translate"
            [matTooltipDisabled]="hasCreateGroupPermission"
          ></i>
        </button>

        <button
          *ngIf="filtered"
          mat-stroked-button
          matTooltip="{{ 'GROUPS.FILTER_CLEAR' | translate }}"
          (click)="clearFilters()"
        >
          <i class="angularjs-fuse-icon icon-filter-remove"></i>
        </button>

        <button
          *ngIf="hasCreateExportPermission"
          mat-stroked-button
          matTooltip="{{ 'GROUPS.EXPORT_EXCEL' | translate }}"
          (click)="openExportDialog()"
          [disabled]="!totalCount"
        >
          <i class="angularjs-fuse-icon icon-file-excel"></i>
        </button>

        <button
          mat-stroked-button
          matTooltip="{{ 'GROUPS.FILTER.TITLE' | translate }}"
          (click)="toggleFilterGroupsSidebar()"
        >
          <i class="angularjs-fuse-icon icon-filter"></i>
        </button>

        <button mat-stroked-button matTooltip="{{ 'GROUPS.RELOAD' | translate }}" (click)="reload()">
          <i class="angularjs-fuse-icon icon-reload small"></i>
        </button>
      </div>
    </div>

    <div class="content-card datatable">
      <mat-table
        #datatable
        class="datatable__table"
        [dataSource]="groups"
        fusePerfectScrollbar
        matSort
        [matSortDisableClear]="true"
      >
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef fxFlex="30" mat-sort-header>
            {{ 'GROUPS.HEADER.NAME' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let group" fxFlex="30" fxFlex.xs="100" fxLayoutAlign="space-between center">
            <span class="mobile-label">{{ 'GROUPS.HEADER.NAME' | translate }}:</span>
            <span class="limit-cells" [matTooltipShowDelay]="500" [matTooltip]="group.name">
              {{ group.name }}
            </span>
            <fc-custom-badge
              *ngIf="group.archived"
              text="{{ 'GROUPS.ARCHIVED' | translate }}"
              textColor="#757575"
              bgColor="#CFCFCF"
            ></fc-custom-badge>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef fxFlex="50">
            {{ 'GROUPS.HEADER.DESCRIPTION' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let group" fxFlex="50" fxFlex.xs="100">
            <span class="mobile-label">{{ 'GROUPS.HEADER.DESCRIPTION' | translate }}:</span>
            <span
              class="limit-cells"
              [matTooltipShowDelay]="500"
              [matTooltip]="group.description"
              [matTooltipDisabled]="!group.description"
            >
              {{ group.description || '-' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <mat-header-cell *matHeaderCellDef fxFlex="15" mat-sort-header>
            {{ 'GROUPS.HEADER.CREATED_AT' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let group" fxFlex="15" fxFlex.xs="100">
            <span class="mobile-label">{{ 'GROUPS.HEADER.CREATED_AT' | translate }}:</span>
            <span
              class="limit-cells"
              [matTooltipShowDelay]="500"
              [matTooltip]="group.createdAt | date: 'dd/MM/yyyy HH:mm'"
            >
              {{ group.createdAt | date: 'dd/MM/yyyy HH:mm' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef fxFlex="7">
            {{ 'GROUPS.HEADER.ACTIONS' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let group" fxFlex="7" fxFlex.xs="100">
            <span class="mobile-label uppercase" fxHide fxShow.xs>{{ 'GROUPS.EDIT' | translate }}</span>
            <button
              mat-icon-button
              (click)="openDialog(group.id)"
              [matTooltip]="(hasEditGroupPermission ? 'GROUPS.EDIT' : 'GROUPS.VIEW') | translate"
            >
              <img src="assets/images/icons/new_icon_edit_action.svg" alt="edit group" />
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="noData">
          <mat-footer-cell
            *matFooterCellDef
            [attr.colspan]="displayedColumns.length"
            fxLayout="column"
            fxLayoutAlign="center center"
          >
            {{ 'GROUPS.NO_DATA' | translate }}
          </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="loading">
          <mat-footer-cell
            *matFooterCellDef
            [attr.colspan]="displayedColumns.length"
            fxLayout="column"
            fxLayoutAlign="center center"
          >
            <div class="p-24" fxLayout="column" fxLayoutAlign="center center">
              <mat-spinner color="primary" diameter="64" class="mb-24"></mat-spinner>
              {{ 'GROUPS.LOADING' | translate }}
            </div>
          </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" [class.display-none]="loading"></mat-row>
        <mat-footer-row *matFooterRowDef="['noData']" [hidden]="loading || groups?.length"></mat-footer-row>
        <mat-footer-row *matFooterRowDef="['loading']" [hidden]="!loading"></mat-footer-row>
      </mat-table>
      <mat-paginator [length]="totalCount" [pageSizeOptions]="[25, 50, 100, 200, 250]"></mat-paginator>
    </div>
  </div>
</div>

<fuse-sidebar name="filterGroups" position="right" lockedOpen="true">
  <filter-groups class="sidebar-filter"></filter-groups>
</fuse-sidebar>
